exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card{\r\n    width: 100%;\r\n    background-color: var(--grey-color);\r\n}\r\n.card-title{\r\n    font-size: 3rem;\r\n    padding: 80px;\r\n}\r\nh1{\r\n    padding: 50px 0;\r\n}\r\nh2{\r\n    padding: 50px 0;\r\n}\r\n.card-body{\r\n    background-color: white;\r\n    margin: 0 10vw;\r\n}\r\n@media only screen and (max-width: 900px) {\r\n    .card-title{\r\n        font-size: 1rem;\r\n        padding: 0;\r\n    }\r\n    img{\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/active/active.component.css
// module id = ../../../../../src/app/active/active.component.css
// module chunks = main